// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navbar Container */
.navbar {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #222;
  padding: 15px 20px; /* Default padding */
  color: white;
  position: relative;
}

/* Desktop Navigation (Centered) */
.nav-links {
  display: flex;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

.nav-links li {
  margin: 0 20px;
}

.nav-links a {
  text-decoration: none;
  color: white;
  font-size: 16px;
  font-weight: 600;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: #9cb6c0;
}

/* Mobile Menu Icon (Left-Aligned) */
.menu-icon {
  display: none;
  cursor: pointer;
  color: white;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

/* Sidebar - Adjusted to prevent breaking */
.sidebar {
  position: fixed;
  top: 0;
  left: -75vw; /* Initially hidden */
  width: 75vw; /* Reduced width */
  max-width: 320px; /* Prevent excessive stretching */
  height: 100vh;
  background: rgba(15, 15, 15, 0.97);
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  box-shadow: 5px 0 15px rgba(0, 0, 0, 0.3);
  transition: left 0.3s ease-in-out;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  z-index: 1000;
}

.sidebar.open {
  left: 0; /* Slide in */
}

/* Sidebar Header with Close Button */
.sidebar-header {
  display: flex;
  justify-content: flex-end;
  padding: 15px;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 26px;
}

/* Sidebar Links - Proper Spacing */
.sidebar ul {
  list-style: none;
  padding: 50px 20px;
}

.sidebar li {
  margin: 25px 0; /* Better spacing */
  text-align: left;
}

.sidebar a {
  text-decoration: none;
  color: white;
  font-size: 20px; /* Readable text */
  font-weight: bold;
  display: block;
  padding: 12px;
  transition: background 0.3s, color 0.3s;
  border-radius: 8px;
}

/* Active Page */
.sidebar a.active {
  background: rgba(255, 255, 255, 0.15);
  color: #9cb6c0;
}

.sidebar a:hover {
  background: rgba(255, 255, 255, 0.1);
  color:  #9cb6c0;
  ;
}

/* Overlay - Darkens Background When Sidebar is Open */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 900;
}

/* Mobile-Specific Fixes */
@media screen and (max-width: 768px) {
  .navbar {
    padding: 25px 25px; /* Increased padding for better spacing */
  }

  .menu-icon {
    display: block;
    font-size: 26px; /* Slightly larger for better tap area */
  }

  .nav-links {
    display: none;
  }

  .sidebar {
    width: 75vw; /* Ensure width doesn't take full screen */
    max-width: 300px; /* Keep it constrained */
  }

  .sidebar ul {
    padding: 60px 20px; /* Adjusted padding */
  }

  .sidebar li {
    margin: 28px 0; /* More spacing */
  }

  .sidebar a {
    font-size: 20px; /* Bigger text */
    padding: 16px; /* Comfortable touch area */
  }
}`, "",{"version":3,"sources":["webpack://./src/Navbar.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB,EAAE,oBAAoB;EACxC,YAAY;EACZ,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,MAAM;EACN,WAAW,EAAE,qBAAqB;EAClC,WAAW,EAAE,kBAAkB;EAC/B,gBAAgB,EAAE,iCAAiC;EACnD,aAAa;EACb,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;EAC1B,yCAAyC;EACzC,iCAAiC;EACjC,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,OAAO,EAAE,aAAa;AACxB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe,EAAE,kBAAkB;EACnC,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,eAAe;;AAEjB;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE;IACE,kBAAkB,EAAE,yCAAyC;EAC/D;;EAEA;IACE,cAAc;IACd,eAAe,EAAE,wCAAwC;EAC3D;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW,EAAE,0CAA0C;IACvD,gBAAgB,EAAE,wBAAwB;EAC5C;;EAEA;IACE,kBAAkB,EAAE,qBAAqB;EAC3C;;EAEA;IACE,cAAc,EAAE,iBAAiB;EACnC;;EAEA;IACE,eAAe,EAAE,gBAAgB;IACjC,aAAa,EAAE,2BAA2B;EAC5C;AACF","sourcesContent":["/* Navbar Container */\n.navbar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #222;\n  padding: 15px 20px; /* Default padding */\n  color: white;\n  position: relative;\n}\n\n/* Desktop Navigation (Centered) */\n.nav-links {\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n\n.nav-links li {\n  margin: 0 20px;\n}\n\n.nav-links a {\n  text-decoration: none;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  transition: color 0.3s;\n}\n\n.nav-links a:hover {\n  color: #9cb6c0;\n}\n\n/* Mobile Menu Icon (Left-Aligned) */\n.menu-icon {\n  display: none;\n  cursor: pointer;\n  color: white;\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n/* Sidebar - Adjusted to prevent breaking */\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: -75vw; /* Initially hidden */\n  width: 75vw; /* Reduced width */\n  max-width: 320px; /* Prevent excessive stretching */\n  height: 100vh;\n  background: rgba(15, 15, 15, 0.97);\n  backdrop-filter: blur(6px);\n  box-shadow: 5px 0 15px rgba(0, 0, 0, 0.3);\n  transition: left 0.3s ease-in-out;\n  border-top-right-radius: 12px;\n  border-bottom-right-radius: 12px;\n  z-index: 1000;\n}\n\n.sidebar.open {\n  left: 0; /* Slide in */\n}\n\n/* Sidebar Header with Close Button */\n.sidebar-header {\n  display: flex;\n  justify-content: flex-end;\n  padding: 15px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: white;\n  cursor: pointer;\n  font-size: 26px;\n}\n\n/* Sidebar Links - Proper Spacing */\n.sidebar ul {\n  list-style: none;\n  padding: 50px 20px;\n}\n\n.sidebar li {\n  margin: 25px 0; /* Better spacing */\n  text-align: left;\n}\n\n.sidebar a {\n  text-decoration: none;\n  color: white;\n  font-size: 20px; /* Readable text */\n  font-weight: bold;\n  display: block;\n  padding: 12px;\n  transition: background 0.3s, color 0.3s;\n  border-radius: 8px;\n}\n\n/* Active Page */\n.sidebar a.active {\n  background: rgba(255, 255, 255, 0.15);\n  color: #9cb6c0;\n}\n\n.sidebar a:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color:  #9cb6c0;\n  ;\n}\n\n/* Overlay - Darkens Background When Sidebar is Open */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 900;\n}\n\n/* Mobile-Specific Fixes */\n@media screen and (max-width: 768px) {\n  .navbar {\n    padding: 25px 25px; /* Increased padding for better spacing */\n  }\n\n  .menu-icon {\n    display: block;\n    font-size: 26px; /* Slightly larger for better tap area */\n  }\n\n  .nav-links {\n    display: none;\n  }\n\n  .sidebar {\n    width: 75vw; /* Ensure width doesn't take full screen */\n    max-width: 300px; /* Keep it constrained */\n  }\n\n  .sidebar ul {\n    padding: 60px 20px; /* Adjusted padding */\n  }\n\n  .sidebar li {\n    margin: 28px 0; /* More spacing */\n  }\n\n  .sidebar a {\n    font-size: 20px; /* Bigger text */\n    padding: 16px; /* Comfortable touch area */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
